import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51b50f40"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "flex relative py-0 px-4 dark:bg-gradient-2 bg-gradient-4 shadow-md"
}
const _hoisted_2 = { class: "absolute right-6 top-4 text-black" }
const _hoisted_3 = { class: "flex flex-1 items-center justify-center min-h-[3.5rem]" }
const _hoisted_4 = { class: "banner-content flex justify-center text-center w-fit pt-0 pr-4 pb-0 pl-6" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 1,
  class: "pl-4 pr-8 border-l border-solid border-black"
}
const _hoisted_7 = { class: "flex" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChIcon = _resolveComponent("ChIcon")!

  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      (_ctx.banner?.enabled && _ctx.showBanner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("a", {
                href: "#",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeBanner && _ctx.closeBanner(...args)))
              }, [
                _createVNode(_component_ChIcon, {
                  icon: "fa-xmark",
                  "icon-type": "fa-light"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_ctx.banner.image)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "w-10 h-10 bg-cover bg-center rounded-full p-4",
                    style: _normalizeStyle({ 'background-image': `url(${_ctx.banner.image})` })
                  }, null, 4))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", {
                  class: "font-normal text-sm text-black leading-5",
                  innerHTML: _ctx.banner.content
                }, null, 8, _hoisted_5)
              ]),
              (_ctx.banner.cta.url)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, [
                      _createElementVNode("a", {
                        class: "font-bold text-sm text-black no-underline",
                        href: _ctx.banner.cta.url,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickCta(_ctx.banner.cta.url))),
                        target: "_blank"
                      }, [
                        _createTextVNode(_toDisplayString(_ctx.banner.cta.text) + " ", 1),
                        _createVNode(_component_ChIcon, {
                          icon: "fa-arrow-right",
                          "icon-type": "fa-regular"
                        })
                      ], 8, _hoisted_8)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}